/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Loader from 'Component/Loader';

import './VfitsVehiclesByProduct.style';

/** @namespace Pwa/Component/VfitsVehiclesByProduct/Component/VfitsVehiclesByProductComponent */
export class VfitsVehiclesByProductComponent extends PureComponent {
    static propTypes = {
        vehicles: PropTypes.arrayOf(PropTypes.shape(
            {
                make: PropTypes.string,
                model: PropTypes.string,
                option: PropTypes.string,
                years: PropTypes.arrayOf(PropTypes.number),
                yearsGrouped: PropTypes.arrayOf(PropTypes.string)
            }
        )),
        isLoading: PropTypes.bool,
        isError: PropTypes.bool
    };

    static defaultProps = {
        vehicles: [],
        isLoading: false,
        isError: false
    };

    renderVehicleItem(vehicle, index) {
        const {
            make,
            model,
            option,
            yearsGrouped
        } = vehicle;

        return (
            <div
              key={ index }
              block="VfitsVehiclesByProduct"
              elem="VehicleItem"
            >
                <div
                  block="VfitsVehiclesByProduct"
                  elem="VehicleDetails"
                >
                    <span
                      block="VfitsVehiclesByProduct"
                      elem="Make"
                    >
                        { make }
                    </span>
                    <span
                      block="VfitsVehiclesByProduct"
                      elem="Model"
                    >
                        { model }
                    </span>
                    { option && (
                        <span
                          block="VfitsVehiclesByProduct"
                          elem="Option"
                        >
                            { option }
                        </span>
                    ) }
                </div>
                <div
                  block="VfitsVehiclesByProduct"
                  elem="Years"
                >
                    { yearsGrouped.join(', ') }
                </div>
            </div>
        );
    }

    renderVehiclesList() {
        const { vehicles } = this.props;

        if (!vehicles.length) {
            return (
                <div
                  block="VfitsVehiclesByProduct"
                  elem="NoVehicles"
                >
                    { __('No supported vehicles found for this product.') }
                </div>
            );
        }

        return (
            <div
              block="VfitsVehiclesByProduct"
              elem="VehiclesList"
            >
                { vehicles.map((vehicle, index) => this.renderVehicleItem(vehicle, index)) }
            </div>
        );
    }

    renderError() {
        return (
            <div
              block="VfitsVehiclesByProduct"
              elem="Error"
            >
                { __('Unable to load supported vehicles. Please try again later.') }
            </div>
        );
    }

    renderContent() {
        const { isLoading, isError } = this.props;

        if (isLoading) {
            return <Loader />;
        }

        if (isError) {
            return this.renderError();
        }

        return this.renderVehiclesList();
    }

    render() {
        return (
            <div
              block="VfitsVehiclesByProduct"
            >
                <div
                  block="VfitsVehiclesByProduct"
                  elem="Header"
                >
                    <p
                      block="VfitsVehiclesByProduct"
                      elem="Description"
                    >
                        { __('This product is compatible with the following vehicles:') }
                    </p>
                </div>
                { this.renderContent() }
            </div>
        );
    }
}

export default VfitsVehiclesByProductComponent;
